const s3AgilitiesLabels = {
    fr: {
        ai: 'Agilité intellectuelle',
        as: 'Agilité sociale',
        ad: 'Agilité digitale',
        am: 'Agilité managériale',
        ac: 'Agilité commerciale',
        ag: 'Agilité générale'
    },
    en: {
        ai: "Intellectual agility",
        as: "Social agility",
        ad: "Digital agility",
        am: "Managerial agility",
        ac: "Commercial agility",
        ag: "General agility"
    }
}
export default s3AgilitiesLabels
